import showdown from 'showdown';

export default class MarkdownService {

	convertMarkdown(text) {
		var converter = new showdown.Converter({simpleLineBreaks: true, ghCompatibleHeaderId: false});
		var html = converter.makeHtml(text);

		return html;
	}
}